<ng-template #emptyproducts let-icon="icon" let-message="message" let-dataid="dataid">
    <div class="empty">
        <ion-card [uppDataid]="dataid || null">
            <ion-icon [name]="icon || 'wine-outline'"></ion-icon>
            <ion-card-header>
                <ion-card-title>{{tr('@place_products_empty_title')}}</ion-card-title>
            </ion-card-header>
            <ion-card-content *ngIf="message">
                {{tr(message)}}
            </ion-card-content>
        </ion-card>
    </div>
</ng-template>

<upp-visible-control mode="fill">
    <upp-application-page>
        <upp-panel lines="hide" [size]="view.Mobile ? 'auto' : 'large'">
            <div #swipeHost class="guestorder-swipe-host" [hidden]="!!ConfiguringProduct">
                <div class="guestorder-catalog-layer guestorder-layer" [hidden]="ShowCart">
                    <upp-panel-header>
                        <upp-header menu="hide">
                            <upp-header-content>
                                <div uppDataid="guestorder-search">
                                    <upp-search
                                        placeholder="{{tr('@place_product_search')}}"
                                        [(ngModel)]="search.criteria"
                                    ></upp-search>
                                </div>
                            </upp-header-content>
                            <upp-header-button size="large" uppDataid="guestorder-back-button" (click)="OnDismiss()">
                                <ion-icon name="arrow-back-outline"></ion-icon>
                            </upp-header-button>
                        </upp-header>
                        <ng-container *ngTemplateOutlet="orderstatus"></ng-container>
                    </upp-panel-header>
                    <upp-panel-content class="guestorder-body">
                        <ng-container *ngIf="(search.Searching !== true) && !HasCatalogProducts" [ngTemplateOutlet]="emptyproducts" [ngTemplateOutletContext]="{ dataid: 'guestorder-noproducts-warning', message: '@place_products_empty_message' }"></ng-container>

                        <ng-container *ngIf="(search.Searching === true) || HasCatalogProducts">
                            <ion-item *ngIf="search.Searching === true" color="warning" class="search-banner">
                                <ion-label class="title">{{tr('@place_show_search_results', [ search.criteria ])}}</ion-label>
                                <ion-icon slot="end" name="close-outline" (click)="search.Clear()"></ion-icon>
                            </ion-item>

                            <upp-guest-catalog
                                [place]="place"
                                [ticket]="ticket"
                                [results]="search.Searching ? search.results : null"
                                (Select)="OnSelect($event)"
                            ></upp-guest-catalog>
                        </ng-container>
                    </upp-panel-content>
                    <upp-panel-footer *ngIf="ticket" uppDataid="guestorder-footer">
                        <ion-item class="guestorder-toolbar" lines="none">
                            <ion-label class="ticket-summary" (click)="OnShowCart()" uppDataid="guestorder-ticket-summary">
                                <span class="title-field">
                                    <ion-icon name="cart-outline"></ion-icon>
                                    <span class="size">{{ticket.ProductsLength}}</span>
                                </span>
                                <span class="title-field">
                                    <span class="price">{{ticket.priceinfo.int}},<span class="decimal">{{ticket.priceinfo.dec}}</span>{{tr('@currency')}}</span>
                                </span>
                            </ion-label>
                            <ion-buttons slot="end" class="ticket-actions">
                                <ion-button class="show-cart" uppDataid="guestorder-show-cart-button"
                                    mode="md"
                                    (click)="OnShowCart()"
                                >
                                    <ion-icon name="cart-outline" slot="start"></ion-icon>
                                    {{ tr('@place_request_showcart') }}
                                </ion-button>
                            </ion-buttons>
                        </ion-item>
                    </upp-panel-footer>
                </div>

                <div class="guestorder-cart-layer guestorder-layer" [hidden]="!ShowCart">
                    <ng-container *ngIf="CartLoaded">
                        <upp-panel-header>
                            <upp-header color="light" menu="hide" lines="success">
                                <upp-header-title>
                                    <ng-container *ngIf="ticket">
                                        <span class="title-field">
                                            <ion-icon name="cart-outline"></ion-icon>
                                            <span class="size">{{ticket.ProductsLength}}</span>
                                        </span>
                                        <span class="title-field">
                                            <span class="price">{{ticket.priceinfo.int}},<span class="decimal">{{ticket.priceinfo.dec}}</span>{{tr('@currency')}}</span>
                                        </span>
                                    </ng-container>
                                </upp-header-title>
                                <upp-header-button size="large" uppDataid="guestorder-cart-back" (click)="OnHideCart()">
                                    <ion-icon name="arrow-back-outline"></ion-icon>
                                </upp-header-button>
                                <upp-header-button size="large" uppDataid="guestorder-cancel-button" (click)="OnCancel($event)">
                                    <ion-icon name="close-outline"></ion-icon>
                                </upp-header-button>
                            </upp-header>
                            <ng-container *ngTemplateOutlet="orderstatus"></ng-container>
                        </upp-panel-header>
                        <upp-panel-content class="guestorder-body --no-fill-children">
                            <upp-form layout="fill">
                                <ng-container *ngIf="ticket?.IsEmpty" [ngTemplateOutlet]="emptyproducts" [ngTemplateOutletContext]="{ icon: 'cart-outline' }"></ng-container>
                                <ng-container *ngIf="ticket && !ticket.IsEmpty">
                                    <upp-form-section fill="clear" class="section-gap">
                                        <ion-item class="title">
                                            <ion-label>{{tr('@place_ticket_products_to_prepare_title')}}</ion-label>
                                        </ion-item>
                                        <ng-container *ngFor="let line of ticket.products; trackBy: TicketProductTrack">
                                            <upp-product-ticket
                                                [product]="line"
                                                mode="EDIT"
                                                (ToPanel)="OnCartLineConfigure($event)"
                                                (Updated)="OnCartUpdated()"
                                            ></upp-product-ticket>
                                        </ng-container>
                                    </upp-form-section>
                                    <upp-form-section *ngIf="ticket.extras.length > 0" fill="clear" class="section-gap">
                                        <ion-item class="title">
                                            <ion-label color="dark">{{tr('@ticket_order_extras_title')}}</ion-label>
                                        </ion-item>
                                        <ng-container *ngFor="let _extra of ticket.extras; trackBy: ExtraTrack">
                                            <upp-extra-ticket uppDataid="guestorder-extra-info" mode="VIEW" [extra]="_extra"></upp-extra-ticket>
                                        </ng-container>
                                    </upp-form-section>
                                    <upp-form-section *ngIf="ticket.offers.length > 0" fill="clear" class="section-gap">
                                        <ion-item class="title">
                                            <ion-label color="dark">{{tr('@ticket_order_offers_title')}}</ion-label>
                                        </ion-item>
                                        <ng-container *ngFor="let _offer of ticket.offers; trackBy: OfferTrack">
                                            <upp-offer-ticket
                                                *ngIf="_offer.Display"
                                                uppDataid="guestorder-offer-info"
                                                mode="VIEW"
                                                [offer]="_offer"
                                            ></upp-offer-ticket>
                                        </ng-container>
                                    </upp-form-section>
                                    <upp-form-section *ngIf="ticket.discounts.length > 0" fill="clear" class="section-gap">
                                        <ion-item class="title">
                                            <ion-label color="dark">{{tr('@ticket_order_discounts_title')}}</ion-label>
                                        </ion-item>
                                        <ng-container *ngFor="let _discount of ticket.discounts; trackBy: DiscountTrack">
                                            <upp-offer-ticket
                                                uppDataid="guestorder-discount-info"
                                                mode="VIEW"
                                                [discount]="_discount"
                                            ></upp-offer-ticket>
                                        </ng-container>
                                    </upp-form-section>
                                    <upp-form-section fill="clear" class="section-gap">
                                        <ion-item class="title">
                                            <ion-label color="dark">{{tr('@ticket_order_notes')}}</ion-label>
                                        </ion-item>
                                        <upp-textarea
                                            uppDataid="guestorder-notes-area"
                                            [rows]="5"
                                            [(ngModel)]="Comments"
                                            placeholder="{{tr('@ticket_order_notes_ph')}}"
                                        ></upp-textarea>
                                    </upp-form-section>
                                </ng-container>
                            </upp-form>
                        </upp-panel-content>
                        <upp-panel-footer *ngIf="ticket" uppDataid="guestorder-cart-footer">
                            <ion-item class="guestorder-toolbar" lines="none">
                                <ion-buttons slot="start" class="ticket-actions">
                                    <ion-button class="continue" uppDataid="guestorder-continue-button"
                                        mode="md"
                                        (click)="OnHideCart()"
                                    >
                                        <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
                                        {{ tr('@place_request_continue') }}
                                    </ion-button>
                                </ion-buttons>
                                <ion-buttons slot="end" class="ticket-actions">
                                    <ion-button class="send" uppDataid="guestorder-send-button"
                                        mode="md"
                                        [class.send-blocked]="IsOrdersBlocked"
                                        [disabled]="IsSending || (!CanSubmitOrder && !IsOrdersBlocked)"
                                        (click)="OnSendTicket($event)"
                                    >
                                        <ion-icon name="paper-plane-outline" slot="start"></ion-icon>
                                        {{ tr('@place_request_send') }}
                                    </ion-button>
                                </ion-buttons>
                            </ion-item>
                        </upp-panel-footer>
                    </ng-container>
                </div>
            </div>

            <ng-template #orderstatus>
                <ion-item
                    *ngIf="OrderStatus"
                    class="guestorder-status"
                    color="warning"
                    lines="none"
                    uppDataid="guestorder-status"
                >
                    <ion-icon slot="start" name="warning-outline"></ion-icon>
                    <ion-label>
                        {{ tr(OrderStatusTitle) }}<br/>
                        <span class="small">{{ tr(OrderStatusMessage) }}</span>
                    </ion-label>
                </ion-item>
            </ng-template>

            <upp-product-cart *ngIf="ConfiguringProduct"
                class="guestorder-configurator"
                [place]="place"
                [ticket]="ticket"
                [product]="ConfiguringProduct"
                [options]="ConfiguringOptions"
                [incart]="ConfiguringCartAmount"
                (ToPanel)="OnConfiguratorClosed()"
            ></upp-product-cart>
        </upp-panel>
    </upp-application-page>
</upp-visible-control>
